import React, { useState } from "react";
import { forgotPassword } from "../../api/auth.api";
import { toast } from "react-toastify";

const ForgotPassword = ({ closeModal }) => {

  const [loading, setLoading] = useState(false);

  const [values, setValues] = useState({
    email: "",
    role: "BUYER"
  });

  const handleChange = (e) => {

    setValues({
      ...values,
      [e.target.name]: e.target.value
    });

  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const res = await forgotPassword(values);

      toast.success(res.data.message);

    } catch (e) {

      toast.error(
        e.response?.data?.message ||
        "Something went wrong"
      );

    } finally {

      setLoading(false);

    }

  };

  const inputStyle = {
    backgroundColor: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    padding: "12px 16px",
    width: "100%",
    marginBottom: "20px",
    outline: "none",
    fontSize: "clamp(14px, 1.2vw, 16px)"
  };

  return (
    <div
      style={{
        maxWidth: "500px",
        width: "90%", // Mobile safety
        margin: "0 auto",
        backgroundColor: "#fff",
        padding: "clamp(20px, 5vw, 40px)", // Fluid padding
        borderRadius: "12px",
        border: "1px solid #e5e7eb",
        position: "relative"
      }}
    >

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-start mb-4">

        <div>
          <h3
            className="fw-bold mb-1"
            style={{
              color: "#112347",
              fontSize: "clamp(20px, 3vw, 28px)" // Fluid title
            }}
          >
            Forgot Password
          </h3>

          <p className="text-muted m-0" style={{ fontSize: "clamp(13px, 1vw, 15px)" }}>
            Enter your registered email
          </p>
        </div>

        <span
          onClick={closeModal}
          style={{
            cursor: "pointer",
            fontSize: "22px",
            fontWeight: "bold",
            lineHeight: 1
          }}
        >
          ✕
        </span>

      </div>

      {/* FORM */}
      <form onSubmit={handleSubmit}>

        <select
          name="role"
          value={values.role}
          onChange={handleChange}
          style={inputStyle}
        >
          <option value="BUYER">
            Buyer
          </option>

          <option value="SELLER">
            Seller
          </option>
        </select>

        <input
          type="email"
          name="email"
          placeholder="Enter Email"
          value={values.email}
          onChange={handleChange}
          style={inputStyle}
          required
        />

        <button
          type="submit"
          disabled={loading}
          className="btn w-100 py-3 fw-bold text-white"
          style={{
            backgroundColor: "#112347",
            opacity: loading ? 0.7 : 1,
            fontSize: "clamp(14px, 1.2vw, 16px)"
          }}
        >
          {
            loading
              ? "Sending Link..."
              : "Send Reset Link"
          }
        </button>

      </form>

    </div>
  );

};

export default ForgotPassword;